import { jsx } from "react/jsx-runtime";
import RemoveIcon from "@mui/icons-material/Remove";
import { validateTidalLicense } from "../../base/index.js";
function Remove(props) {
  return /* @__PURE__ */ jsx(
    RemoveIcon,
    {
      "data-testid": "Remove",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Remove",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
Remove.tidalIconMeta = {
  categories: "cancel,informative",
  name: "Remove"
};
validateTidalLicense();
export {
  Remove
};
//# sourceMappingURL=Remove.js.map
